import {TText, TRecord, TList} from '@packages/systems/wfdl-ast';
import {TDateTime} from '@packages/systems/plugins/DateTime';
import {TBoolean} from '@packages/systems/plugins-utils/Boolean';

// We get the WFDL type representation to use in the plugin
export const createInviteUserWFDLType = () => {
  return TRecord({
    _id: TText,
    invitedOn: TDateTime,
    createdOn: TDateTime,
    updatedOn: TDateTime,
    emailVerified: TBoolean,
    data: TRecord({
      name: TText,
      email: TText,
      'accept-communications': TBoolean,
      'accept-privacy': TBoolean,
    }),
    status: TText,
    accessGroups: TList(
      TRecord({
        slug: TText,
        type: TText,
      })
    ),
  });
};

// We have as a separate type in case we want to adjust the Delete User output type
export const createDeleteUserWFDLType = () => {
  return TRecord({
    _id: TText,
    createdOn: TDateTime,
    updatedOn: TDateTime,
    emailVerified: TBoolean,
    data: TRecord({
      name: TText,
      email: TText,
      'accept-communications': TBoolean,
      'accept-privacy': TBoolean,
    }),
    status: TText,
    accessGroups: TList(
      TRecord({
        slug: TText,
        type: TText,
      })
    ),
  });
};
